import { defineModule } from '@/lib/module-routes'

import { devBroadcastRoute } from './routes'

export const notificationsModule = defineModule({
  routes: [devBroadcastRoute],
})
